var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgUrl = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M5.54 6h12.92c.806 0 1.58.316 2.15.879S21.5 8.204 21.5 9v6a2.98 2.98 0 0 1-.89 2.121 3.06 3.06 0 0 1-2.15.879H5.54a3.06 3.06 0 0 1-2.15-.879A2.98 2.98 0 0 1 2.5 15V9c0-.796.32-1.559.89-2.121A3.06 3.06 0 0 1 5.54 6m4.818 5.676c.526-.519 1.444-.519 1.97 0l.329.324.656-.648-.328-.324a2.3 2.3 0 0 0-1.642-.671 2.32 2.32 0 0 0-1.641.671L8.716 12a2.28 2.28 0 0 0-.679 1.62c0 .608.244 1.19.679 1.62a2.33 2.33 0 0 0 1.642.671 2.33 2.33 0 0 0 1.642-.67l.328-.324-.656-.648-.329.324a1.407 1.407 0 0 1-1.97 0 1.37 1.37 0 0 1 0-1.945zM12 8.758l-.328.325.656.648.329-.324a1.407 1.407 0 0 1 1.97 0 1.37 1.37 0 0 1 0 1.945l-.985.972c-.526.519-1.444.519-1.97 0L11.343 12l-.656.648.328.324a2.3 2.3 0 0 0 1.642.671 2.32 2.32 0 0 0 1.641-.671l.986-.972a2.28 2.28 0 0 0 .679-1.62 2.28 2.28 0 0 0-.679-1.62 2.34 2.34 0 0 0-1.642-.67A2.34 2.34 0 0 0 12 8.757Z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgUrl);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/url.afa96936.svg";